import React, { useState, useEffect } from "react";
import Select from "react-select";
import LeagueOverviewTable from "./LeagueOverviewTable";
import "./css/league_overview.css";

const LeagueOverview = (props) => {
  // Set title
  useEffect(() => {
    document.title = "Fantasy League Weekly Rankings";
  }, []);

  const [currentWeek, setCurrentWeek] = useState(0);
  const [selectedWeek, setSelectedWeek] = useState(null);
  const [weekOptions, setWeekOptions] = useState([]);

  // Fetch current week and initialize options
  const getCurrentWeek = async () => {
    try {
      const response = await fetch("/get_week/" + props.league_id);
      const json = await response.json();
      const week = json["week"];
      setCurrentWeek(week);

      // Create week options (week 1 to current week)
      const options = [];
      for (let i = 1; i <= week; i++) {
        options.push({
          value: i,
          label: `Week ${i}${i === week ? " (Current)" : ""}`,
        });
      }
      setWeekOptions(options);

      // Set default to current week
      setSelectedWeek(options[options.length - 1]);
    } catch (error) {
      console.log("Error fetching week: " + error);
      setCurrentWeek(0);
    }
  };

  useEffect(() => {
    getCurrentWeek();
  }, []);

  const handleWeekChange = (option) => {
    setSelectedWeek(option);
  };

  return (
    <div id="league-overview">
      <div className="pure-g center">
        <div className="pure-u-1-1">
          <header>
            <h1>League Overview</h1>
          </header>
        </div>
      </div>
      <div>
        <div className="pure-g center">
          <div className="pure-u-1-1">
            <div style={{ margin: "20px auto", maxWidth: "300px" }}>
              <label style={{ display: "block", marginBottom: "8px", fontWeight: "bold" }}>
                Select Week:
              </label>
              <Select
                options={weekOptions}
                value={selectedWeek}
                onChange={handleWeekChange}
                isSearchable={false}
              />
            </div>
            {selectedWeek && (
              <>
                <h3>Matchup Stats: Week {selectedWeek.value}</h3>
                <p className="description-text">
                  What record would you have if you played every team in the league this week?
                </p>
                <LeagueOverviewTable
                  league_id="1748254402"
                  week={selectedWeek.value}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeagueOverview;
